module.exports = __webpack_public_path__ + "img/social-feishu-qr.8b72b0aa.jpg";